import { TYPES_PAYMENT } from './payment.types';

const INITIAL_STATE = {
  voucher: {
    payload: null,
    error: null,
    isLoading: false,
  },
  bankAccountList: {
    payload: null,
    error: null,
    isLoading: false,
  },
  submit: {
    payload: null,
    error: null,
    isLoading: false,
  },
  receipt: {
    payload: null,
    error: null,
    isLoading: false,
  },
  cancel: {
    isLoading: false,
  },
  enrollCourse: {
    isLoading: false,
  },
};

const paymentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES_PAYMENT.SET_VOUCHER_CODE_LOADING:
      return {
        ...state,
        voucher: {
          ...state.voucher,
          isLoading: action.isLoading,
        },
      };
    case TYPES_PAYMENT.GET_VOUCHER_CODE:
      return {
        ...state,
        voucher: {
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };

    case TYPES_PAYMENT.SET_SUBMIT_PAYMENT_LOADING:
      return {
        ...state,
        submit: {
          ...state.submit,
          isLoading: action.isLoading,
        },
      };
    case TYPES_PAYMENT.SUBMIT_PAYMENT:
      return {
        ...state,
        submit: {
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };

    case TYPES_PAYMENT.ENROLL_COURSE_LOADING:
      return {
        ...state,
        enrollCourse: {
          isLoading: action.isLoading,
        },
      };
    case TYPES_PAYMENT.ENROLL_COURSE:
      return {
        ...state,
        enrollCourse: {
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };

    case TYPES_PAYMENT.SET_BANK_ACCOUNTS_LOADING:
      return {
        ...state,
        bankAccountList: {
          ...state.bankAccountList,
          isLoading: action.isLoading,
        },
      };
    case TYPES_PAYMENT.GET_BANK_ACCOUNTS:
      return {
        ...state,
        bankAccountList: {
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };

    case TYPES_PAYMENT.SET_UPLOAD_RECEIPT_LOADING:
      return {
        ...state,
        receipt: {
          ...state.receipt,
          isLoading: action.isLoading,
        },
      };
    case TYPES_PAYMENT.PUT_UPLOAD_RECEIPT:
      return {
        ...state,
        receipt: {
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };

    case TYPES_PAYMENT.SET_CANCEL_PAYMENT_LOADING:
      return {
        ...state,
        cancel: {
          isLoading: action.isLoading,
        },
      };

    case TYPES_PAYMENT.RESET_CHECKOUT_STATE:
      return {
        ...state,
        voucher: INITIAL_STATE.voucher,
        submit: INITIAL_STATE.submit,
        receipt: INITIAL_STATE.receipt,
        cancel: INITIAL_STATE.cancel,
        enrollCourse: INITIAL_STATE.enrollCourse,
      };

    default:
      return state;
  }
};

export default paymentReducer;
